<template>
  <v-app :style="styleOptions">
    <app-bar style="z-index: 999999 !important" @grayScale="setGrayScale" />
    <v-main
      :class="$vuetify.breakpoint.smAndDown ? 'pa-0' : ''"
      style="background-color: #f5f5f5"
    >
      <router-view />
    </v-main>
    <footer-map />
    <footer-menu />
    <footer-copyright />
    <v-toast ref="vtoast" />
    <v-loading />
  </v-app>
</template>

<script>
import AppBar from '@/components/AppBar';
import FooterCopyright from '@/components/FooterCopyright';
import FooterMap from '@/components/FooterMap';
import VToast from '@/components/VToast';
import VLoading from '@/components/VLoading';
import FooterMenu from '@/components/FooterMenu';

export default {
  name: 'App',
  components: {
    AppBar,
    FooterCopyright,
    FooterMap,
    VToast,
    VLoading,
    FooterMenu,
  },
  data() {
    return {
      styleOptions: '',
    };
  },
  mounted() {
    this.$root.vtoast = this.$refs.vtoast;
  },
  methods: {
    setGrayScale(value) {
      if (value) {
        this.styleOptions =
          'filter: gray; filter: grayscale(100%); -webkit-filter: grayscale(1)';
      } else {
        this.styleOptions = '';
      }
    },
  },
};
</script>

<style>
@import url('https://fonts.googleapis.com/css?family=Montserrat');

html,
body {
  font-family: 'Montserrat', sans-serif;
}

#app {
  font-family: 'Montserrat', sans-serif;
}
</style>
